import moment from 'moment';

export const DIVERGENCE_WARNING_DAYS = 0;

const getDaysDiff = (
  collectDate?: string,
  storageDate?: string,
): number | null => {
  if (!collectDate || !storageDate) return null;
  const diff = moment(collectDate).diff(moment(storageDate), 'days');
  return Number.isNaN(diff) ? null : Math.abs(diff);
};

interface IBondDivergence {
  isMissingDate: boolean;
  isDivergent: boolean;
  divergenceDays: number | null;
}

export const getBondDivergence = (
  collectDate?: string,
  storageDate?: string,
): IBondDivergence => {
  const divergenceDays = getDaysDiff(collectDate, storageDate);

  return {
    isMissingDate: !collectDate,
    isDivergent:
      divergenceDays !== null && divergenceDays > DIVERGENCE_WARNING_DAYS,
    divergenceDays,
  };
};
